/**
 * 函数节流
 */

export interface ThrottleRes {
  (...rest: any[]): void;
  // 取消节流
  cancel: () => void;
}

export interface ThrottleOptions {
  // 是否在节流开始前先执行一次，默认true
  leading?: boolean;
  // 是否在节流结束后执行最后一次，默认true
  trailing?: boolean;
}

/**
 * 函数节流
 * @param fn 执行函数
 * @param delay 节流延迟 毫秒
 * @param type 节流类型
 */
export default function throttle(
  fn: (...rest: any[]) => void,
  delay = 250,
  options: ThrottleOptions = {
    leading: true,
    trailing: true,
  },
): ThrottleRes {
  let timeoutId = 0;
  let lastTime = 0;
  let isFirstRunned = false;
  const { leading, trailing } = options;

  const _throttle = function (...rest: any[]) {
    if (lastTime === 0) {
      lastTime = Date.now();
    }

    // 执行first第一次
    if (!isFirstRunned && leading && timeoutId === 0) {
      isFirstRunned = true;
      fn(...rest);
    }

    // 如果达到阈值则执行
    if (Date.now() - lastTime >= delay) {
      lastTime = Date.now();
      fn(...rest);
    } else {
      clear();
      // 设置一个delay之后的回调
      timeoutId = window.setTimeout(() => {
        timeoutId = 0;
        lastTime = 0;
        // 清理第一次运行的标记
        isFirstRunned = false;
        if (trailing) {
          fn(...rest);
        }
      }, delay);
    }
  };

  function clear() {
    if (timeoutId) {
      clearTimeout(timeoutId);
      timeoutId = 0;
    }
  }

  _throttle.cancel = function () {
    timeoutId && clearTimeout(timeoutId);
  };

  return _throttle;
}
